import { defineMessages } from 'react-intl'

/** Travel-agent–facing and AgentHub product copy — `docs/product-taxonomy.md` §12. */
const agentHubGlossaryMessages = defineMessages({
  agentExclusive: {
    defaultMessage: 'Agent exclusive',
    id: 'zT4Szs3wDuGibQ8Ce5Rw',
  },
  additionalCommission: {
    defaultMessage: 'Additional commission',
    id: 'vMFF3Rv-F4XB3ii2S4C-',
  },
})

export default agentHubGlossaryMessages
